export default "__VITE_ASSET__BgmIh27D__"